import IBetSlip from '@models/betSlip/IBetSlip';
import System from '@models/betSlip/System';

export function transformBetslipSystemCombinations(betSlip: Pick<IBetSlip, 'selectedSystems'>): string[] {
    return betSlip.selectedSystems.map((system: System) => `${system.getMinNumber()}/${system.getFromNumber()}`);
}
